import { useMemo } from 'react';

import { ProductType } from '@neo.tax/shared/graphql';
import { FiscalYear } from '@neo.tax/shared/hooks/useAllFiscalYears';
import { generateAscPeriodOptions, PeriodNameOption, PeriodNameOptionGroup } from '@neo.tax/shared/utils';

export const useAscPeriodOptionsInSelectedTaxYear = ({
  selectedFiscalYear,
  selectedProduct,
}: {
  selectedFiscalYear: FiscalYear | null;
  selectedProduct: ProductType;
}): {
  defaultPeriodOption: PeriodNameOption | null;
  periodOptions: PeriodNameOptionGroup[];
} => {
  const periodOptions = useMemo(() => {
    if (!selectedFiscalYear || selectedProduct !== ProductType.UsAsc) {
      return {
        defaultPeriodOption: null,
        periodOptions: [],
      };
    }
    return generateAscPeriodOptions(selectedFiscalYear);
  }, [selectedFiscalYear, selectedProduct]);

  return periodOptions;
};
